// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Footer-nav":"Footer_Footer-nav__i8gHW","Footer-copyright":"Footer_Footer-copyright__qCmnv"};